module.exports = __webpack_public_path__ + "static/media/Search_Icon.f649b16d.svg";